import * as React from 'react';
import * as styles from './styles.css';
import { UIText2 } from '@cian/ui-kit';

export function SupplyDemandFooter() {
  return (
    <div className={styles['container']}>
      <UIText2 color="text-secondary-default">
        График показывает значения относительно прошлогоднего уровня, принятого за 100%
      </UIText2>
    </div>
  );
}
